module.exports = __webpack_public_path__ + "img/couples-017.80071be2.jpg";